// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1K-Z-","form":"styles_form__2WiJD"};